import { API_URL } from "../services/api";

// The API may be same-origin (`/api`, prod behind nginx) or a full host
// (`http://127.0.0.1:8000/api`, local dev where media lives on the backend, not
// the CRA dev server). Media paths come back host-relative (`/media/...`), so
// resolve them against the API origin rather than the page origin.
const ORIGIN = (API_URL || "").replace(/\/api\/?$/, "");

export const mediaUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${ORIGIN}/${String(path).replace(/^\/+/, "")}`;
};

export const initials = (name) =>
  (name || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase() || "?";
